var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vl-style-func',{attrs:{"factory":_vm.commentStyle}})
}
var staticRenderFns = []

export { render, staticRenderFns }